module.exports = __webpack_public_path__ + "img/cookies-8416230_1280_thumb.4bc5ba38.jpg";